import { useDocument } from '@/hooks/use-document';
import { DocumentItem } from './document-item';
import { useLocalization } from '@/hooks/use-localization';
import { LevelType } from '../heading-helper/heading-helper';

export type DocumentHandlerProps = {
    categoriesToDisplay: string[];
    handlerId: string;
    headingLevel?: LevelType;
};

export const DocumentHandler = ({ categoriesToDisplay, handlerId, headingLevel = 2 }: DocumentHandlerProps) => {
    const { localize } = useLocalization();
    const { data } = useDocument({
        categoriesToDisplay,
        handlerId,
    });

    if (!data) {
        return null;
    }

    return (
        <div
            data-component="document-handler"
            className="r-flex r-flex-col r-items-center r-space-y-10 r-p-3 lg:r-flex-row lg:r-items-start lg:r-space-x-10 lg:r-space-y-0"
        >
            <DocumentItem title={localize('forms')} items={data.filter(item => item.type === 'forms')} headingLevel={headingLevel} />
            <DocumentItem
                title={localize('terms-and-conditions')}
                items={data.filter(item => item.type === 'terms_and_conditions')}
                headingLevel={headingLevel}
            />
            <DocumentItem title={localize('information')} items={data.filter(item => item.type === 'information')} headingLevel={headingLevel} />
        </div>
    );
};
